import { z } from "zod";

import { ShopifyMetafieldSchema } from "../../../schemas/organization";

export const GetMetafieldRequestQueryParamSchema = z.object({
  type: z.enum(["product", "variant"]),
  id: z.string(),
  key: z.string(),
});
export type GetMetafieldRequestQueryParamType = z.infer<
  typeof GetMetafieldRequestQueryParamSchema
>;

export const GetMetafieldResponseBodySchema = z.object({
  metafield: ShopifyMetafieldSchema.nullish(),
});
export type GetMetafieldResponseBodyType = z.infer<
  typeof GetMetafieldResponseBodySchema
>;
